import { getReadinessTreatment } from '@features/eligibility-checks/theme/readinessTokens';
import type { BlockReadiness } from '@features/eligibility-checks/types/readiness';

import { EVENT_CSS_VARS } from '../styles/cssVariables';

type CSSVars = Record<string, string>;

// Readiness drives stripe + dot only — the background stays as the appointment
// type's tint regardless of readiness state. See eligibility-prototype
// AppointmentBlock.jsx:119 — `bg = withAlpha(typeColor, 0.06)` for all
// non-block / non-actionable variants.
//
// Stripe weight (handoff §4.1.2):
//   0px  → nothing demands attention   (verified, collected, info)
//   3px  → workflow attention          (collect, attention)
//   12px → visit itself in question    (blocked)
export const useReadinessStyling = (readiness: BlockReadiness | null): CSSVars => {
  const treatment = getReadinessTreatment(readiness);
  if (!treatment) return {};

  return {
    [EVENT_CSS_VARS.readiness.stripeWidth]: `${treatment.stripeWidthPx}px`,
    [EVENT_CSS_VARS.readiness.stripeColor]: treatment.color,
  };
};
